import { useEffect, useState, useRef } from "react";
import api from "../../../services/axiosInstance";

export default function StudentsFeedback() {
  const [testimonials, setTestimonials] = useState([]);
  const scrollRef = useRef(null);
  const isDragging = useRef(false);
  const startX = useRef(0);
  const scrollLeft = useRef(0);

  useEffect(() => {
    api
      .get("/testimonials")
      .then((response) => setTestimonials(response.data.testimonials))
      .catch((error) => console.error("Error fetching testimonials:", error));
  }, []);

  // Drag-to-scroll handlers
  const handleMouseDown = (e) => {
    isDragging.current = true;
    startX.current = e.pageX - scrollRef.current.offsetLeft;
    scrollLeft.current = scrollRef.current.scrollLeft;
  };

  const handleMouseLeave = () => {
    isDragging.current = false;
  };

  const handleMouseUp = () => {
    isDragging.current = false;
  };

  const handleMouseMove = (e) => {
    if (!isDragging.current) return;
    e.preventDefault();
    const x = e.pageX - scrollRef.current.offsetLeft;
    const walk = (x - startX.current) * 2; // scroll-fast
    scrollRef.current.scrollLeft = scrollLeft.current - walk;
  };

  return ( 
    <section className="px-4 md:px-12 py-12">
  {/* Title */}
  <h1 className="text-4xl font-bold text-gray-800 mb-10 text-center">
    What Our Students Say
  </h1>

  {/* Testimonials Slider */}
  <div
    ref={scrollRef}
    className="
      flex gap-6
      overflow-x-auto
      px-2
      pb-4
      no-scrollbar
      cursor-grab active:cursor-grabbing
      snap-x snap-mandatory
    "
    onMouseDown={handleMouseDown}
    onMouseLeave={handleMouseLeave}
    onMouseUp={handleMouseUp}
    onMouseMove={handleMouseMove}
  >
    {testimonials.map((item, index) => (
      <div
        key={index}
        className="
          flex-shrink-0
          w-72 md:w-80 lg:w-96
          min-h-[260px]
          bg-white
          p-6
          rounded-2xl
          shadow-md
          border border-gray-100
          flex flex-col justify-between
          transition hover:shadow-lg
          snap-start
        "
      >
        <p className="text-gray-600 leading-relaxed mb-4 line-clamp-6">
          “{item.text}”
        </p>

        <span className="font-semibold text-emerald-600 text-sm">
          — {item.name}
        </span>
      </div>
    ))}
  </div>
</section>

 
  );
}
